function PageNotFound() {
  return (
    <div className="errorPage">
      <h1>404 - Page Not Found</h1>
      <p>Encountered some error! The page you are looking for could not be found.</p>
    </div>
  );
};

export default PageNotFound;
